import React from "react";
import PropTypes from "prop-types";
import Markdown from "react-remarkable";

const DigiFormDescription = ({
  description
}) => (
  <div>
    {description && (
      <div>
        <span className="grey-text line-break">
          <Markdown source={description} />
        </span>
        <hr />
      </div>
    )}
  </div>
);

DigiFormDescription.propType = {
  description: PropTypes.string
};

export default DigiFormDescription;
